// A datasource field that exists but is empty serialises as "", and a missing
// one arrives as null - neither of which a destructuring default catches. Every
// label goes through this instead. Fallbacks are Danish to match the content.
export function label(value: string | undefined | null, fallback: string): string {
    return value?.trim() ? value : fallback;
}
